import { render, staticRenderFns } from "./product-supplier.vue?vue&type=template&id=962e01ca"
import script from "./product-supplier.vue?vue&type=script&lang=js"
export * from "./product-supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports